import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export const mapToArray =
  <T>() =>
  (o: Observable<Record<any, T>>): Observable<T[]> =>
    o.pipe(map((value) => Object.values(value ?? {})));
